import { createSlice } from '@reduxjs/toolkit';
import { editCertificate, getAllCertificates, getAllCertificatesToBulkDownload, getCertificateById, verifyCertificate } from './certificateService';

const initialState = {
  allCertificates: {
    isCertificatesLoading: null,
    isCertificatesSuccess: null,
    certificatesMessage: null,
    pageCount: 0,
    certificates: [],
  },
  editedCertificate: {
    isEditingCertificate: null,
    isCertificateEdited: null,
    certificateEditedMsg: null
  },
  verifyCertificate: {
    isLoadingVerification: null,
    isCertificateVerified: null,
    verifiedCertificate: null
  },
  certificateDetails: {
    isLoadingCertificateDetails: null,
    isCertificateDetailsSuccess: null,
    certificate: null
  },
  bulkCertificates: {
    isBulkCertificatesLoading: null,
    isBulkCertificatesSuccess: null,
    bulkCertificatesMessage: null,
    certificatesBulk: [],
  },
};

const certificatesSlice = createSlice({
  name: 'certificate',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCertificates.pending, (state) => {
        state.allCertificates = {
          ...initialState.allCertificates, // Reset to initial state
          isCertificatesLoading: true,
          certificatesMessage: 'Loading',
        };
      })
      .addCase(getAllCertificates.rejected, (state, action) => {
        state.allCertificates = {
          ...initialState.allCertificates,
          isCertificatesLoading: false,
          isCertificatesSuccess: false,
          certificatesMessage: action.payload || 'Error occurred while fetching certificates',
        };
      })
      .addCase(getAllCertificates.fulfilled, (state, action) => {
        state.allCertificates = {
          ...initialState.allCertificates,
          isCertificatesLoading: false,
          isCertificatesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          certificates: action.payload.data || [],
        };
      });

    //Certificate editing
    builder
      .addCase(editCertificate.pending, (state) => {
        state.editedCertificate = {
          ...initialState.editedCertificate, // Reset to initial state
          isEditingCertificate: true,
          certificateEditedMsg: 'Loading',
        };
      })
      .addCase(editCertificate.rejected, (state, action) => {
        state.editedCertificate = {
          ...initialState.editedCertificate, // Reset to initial state
          isEditingCertificate: false,
          isCertificateEdited: false,
          certificateEditedMsg: action.payload || 'Error occurred while editing the certificate.',
        };
      })
      .addCase(editCertificate.fulfilled, (state, action) => {
        state.editedCertificate = {
          ...initialState.editedCertificate, // Reset to initial state
          isEditingCertificate: false,
          isCertificateEdited: true,
          certificateEditedMsg: action.payload || 'Successfully edited the certificate.',
        };
      });

    //Certificate verify
    builder
      .addCase(verifyCertificate.pending, (state) => {
        state.verifyCertificate = {
          ...initialState.verifyCertificate,
          isLoadingVerification: true,
        };
      })
      .addCase(verifyCertificate.rejected, (state, action) => {
        state.verifyCertificate = {
          ...initialState.verifyCertificate,
          isLoadingVerification: false,
          isCertificateVerified: false,
          verifiedCertificate: action.payload,
        };
      })
      .addCase(verifyCertificate.fulfilled, (state, action) => {
        state.verifyCertificate = {
          ...initialState.verifyCertificate,
          isLoadingVerification: false,
          isCertificateVerified: true,
          verifiedCertificate: action.payload,
        };
      });

    //Certificate details
    builder
      .addCase(getCertificateById.pending, (state) => {
        state.certificateDetails = {
          ...initialState.certificateDetails,
          isLoadingCertificateDetails: true,
        };
      })
      .addCase(getCertificateById.rejected, (state, action) => {
        state.certificateDetails = {
          ...initialState.certificateDetails,
          isLoadingCertificateDetails: false,
          isCertificateDetailsSuccess: false,
        };
      })
      .addCase(getCertificateById.fulfilled, (state, action) => {
        state.certificateDetails = {
          ...initialState.certificateDetails,
          isLoadingCertificateDetails: false,
          isCertificateDetailsSuccess: true,
          certificate: action.payload,
        };
      });

    //Bulk download
    builder
      .addCase(getAllCertificatesToBulkDownload.pending, (state) => {
        state.bulkCertificates = {
          ...initialState.bulkCertificates, // Reset to initial state
          isBulkCertificatesLoadingisBulkCertificatesLoading: true,
          bulkCertificatesMessage: 'Loading',
        };
      })
      .addCase(getAllCertificatesToBulkDownload.rejected, (state, action) => {
        state.bulkCertificates = {
          ...initialState.bulkCertificates,
          isBulkCertificatesLoading: false,
          isBulkCertificatesSuccess: false,
          bulkCertificatesMessage: action.payload || 'Error occurred while fetching certificates',
        };
      })
      .addCase(getAllCertificatesToBulkDownload.fulfilled, (state, action) => {
        state.bulkCertificates = {
          ...initialState.bulkCertificates,
          isBulkCertificatesLoading: false,
          isBulkCertificatesSuccess: true,
          certificatesBulk: action.payload.data || [],
        };
      });
  },
});

export default certificatesSlice.reducer;
